// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3-vQ6","inner":"Footer_inner__27gAr","nextIcon":"Footer_nextIcon__2wMl5","innerLeft":"Footer_innerLeft__FqZma"};